import { decryptData } from "@/utils/crypto";

const ROUTE_PERMISSION_MAP = {
    // Dashboard
    "/dashboard": { dashboardId: 1, moduleName: "Dashboard" },

    // New Visit Management (dashboard_id: 2)
    "/add-leads": { dashboardId: 2, moduleName: "Add New Visit" },
    "/leads-list": { dashboardId: 2, moduleName: "New Visit List" },
    "/Leads-For-Approval": { dashboardId: 2, moduleName: "New Visit for Approval" },
    "/Approved-Leeds": { dashboardId: 2, moduleName: "Approved New Visit" },
    "/Rejected-Leads": { dashboardId: 2, moduleName: "Rejected New Visit" },

    // User Management (dashboard_id: 3)
    "/user-registration": { dashboardId: 3, moduleName: "User Registration" },
    "/users-list": { dashboardId: 3, moduleName: "User List" },
    "/create-user-role": { dashboardId: 3, moduleName: "Create User Role" },
    "/user-role-list": { dashboardId: 3, moduleName: "User Role List" },

    // Area Management (dashboard_id: 4)
    "/Create-Area": { dashboardId: 4, moduleName: "Area Management" },
    "/area-management": { dashboardId: 4, moduleName: "Area Management" },
    "/create-area": { dashboardId: 4, moduleName: "Area Management" },
    "/organization-management": { dashboardId: 4, moduleName: "Area Management" },
    "/create-organization": { dashboardId: 4, moduleName: "Area Management" },
    "/organization-list": { dashboardId: 4, moduleName: "Area Management" },
    "/create-outlet": { dashboardId: 4, moduleName: "Area Management" },
    "/outlet-list": { dashboardId: 4, moduleName: "Area Management" },
    "/outlettype": { dashboardId: 4, moduleName: "Area Management" },

    // Dealer Management (dashboard_id: 5)
    "/dealer-registration": { dashboardId: 5, moduleName: "Dealer Registration" },
    "/dealer-list": { dashboardId: 5, moduleName: "Dealer List" },
    "/dealer-types": { dashboardId: 5, moduleName: "Dealer Registration" },
    "/discount-management": { dashboardId: 5, moduleName: "Dealer Registration" },
    "/view-dealer": { dashboardId: 5, moduleName: "Dealer Registration" },
    "/edit-dealer": { dashboardId: 5, moduleName: "Dealer Registration" },
    "/dealer-information": { dashboardId: 5, moduleName: "Dealer Registration" },

    // Product Management (dashboard_id: 6)
    "/add-products": { dashboardId: 6, moduleName: "Add Product" },
    "/products-list": { dashboardId: 6, moduleName: "Product List" },
    "/products-category": { dashboardId: 6, moduleName: "Add Category" },
    "/category-list": { dashboardId: 6, moduleName: "Category List" },
    "/measurement-list": { dashboardId: 6, moduleName: "Product List" },
    "/stock-list": { dashboardId: 6, moduleName: "Product List" },

    // Route Management (dashboard_id: 7)
    "/create-routes": { dashboardId: 7, moduleName: "Create Routes" },
    "/routes-list": { dashboardId: 7, moduleName: "Routes List" },

    // Collection Management (dashboard_id: 8)
    "/Collection-Bulk-Upload": { dashboardId: 8, moduleName: "Collection Bulk Upload" },
    "/collection-bulk-upload": { dashboardId: 8, moduleName: "Collection Bulk Upload" },
    "/total-collections": { dashboardId: 8, moduleName: "Total Collection" },
    "/total-collections-view": { dashboardId: 8, moduleName: "Total Collection" },
    "/daily-collections": { dashboardId: 8, moduleName: "Total Collection" },
    "/daily-collections-view": { dashboardId: 8, moduleName: "Total Collection" },
    "/overdue-collections": { dashboardId: 8, moduleName: "Overdue Collection" },
    "/approved-overdues": { dashboardId: 8, moduleName: "Approved Overdues" },
    "/daily-pending-inv": { dashboardId: 8, moduleName: "Total Collection" },
    "/CollectionNotify": { dashboardId: 8, moduleName: "Collection Notify List" },

    // Tracking Management (dashboard_id: 9)
    "/live-tracking": { dashboardId: 9, moduleName: "Live Tracking" },
    "/overall-tracking-history": { dashboardId: 9, moduleName: "Tracking History" },
    "/tracking-history": { dashboardId: 9, moduleName: "Tracking History" },
    "/myroute-tracking-history": { dashboardId: 9, moduleName: "Tracking History" },
    "/all-agents": { dashboardId: 9, moduleName: "Live Tracking" },
    "/idling-agents": { dashboardId: 9, moduleName: "Live Tracking" },
    "/parking-agents": { dashboardId: 9, moduleName: "Live Tracking" },

    // Payment Reversal (dashboard_id: 10)
    "/pending-reversals": { dashboardId: 10, moduleName: "Pending Reversals" },
    "/approved-reversals": { dashboardId: 10, moduleName: "Approved Reversals" },
    "/reject-payment-revesals": { dashboardId: 10, moduleName: "Pending Reversals" },
    "/view-reject-payment-revesals": { dashboardId: 10, moduleName: "Approved Reversals" },

    // Daily Summary Report (dashboard_id: 11)
    "/sales-management": { dashboardId: 11, moduleName: "Daily Summary Report" },

    // User Logs (dashboard_id: 12)
    "/user-log": { dashboardId: 12, moduleName: "User Logs" },

    // BulkUpload Management (dashboard_id: 13)
    "/Bulk-Upload": { dashboardId: 13, moduleName: "Bulk Upload" },
};

const normalizeModuleName = (value) => {
    if (!value || typeof value !== "string") return "";
    return value
        .trim()
        .toLowerCase()
        .replace(/[\s_-]+/g, " ");
};

const normalizePath = (path) => {
    if (!path || typeof path !== "string") return "";
    return path
        .split("?")[0]
        .trim()
        .toLowerCase();
};

const isPlaceholderModuleName = (moduleName) => {
    return normalizeModuleName(moduleName) === "module name";
};

const parseDashboardId = (dashboardId) => {
    const parsed = Number(dashboardId);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

const toPermissionFlag = (value) => {
    return Number(value) === 1 || value === true;
};

const normalizePermissionType = (permissionType) => {
    const typeMap = {
        read_premission: "read",
        write_premission: "write",
        delete_premission: "delete",
    };

    return typeMap[permissionType] || permissionType;
};

const getStoredAccessDashboard = () => {
    const decrypted = decryptData(localStorage.getItem("accessDashboard"));

    if (!decrypted) return [];

    if (Array.isArray(decrypted)) {
        return decrypted;
    }

    if (Array.isArray(decrypted.permissions)) {
        return decrypted.permissions;
    }

    if (Array.isArray(decrypted.accessDashboard)) {
        return decrypted.accessDashboard;
    }

    return [];
};

const getRoutePermissionMeta = (routePath) => {
    const normalizedPath = normalizePath(routePath || window.location.pathname);
    if (!normalizedPath) return null;

    if (ROUTE_PERMISSION_MAP[normalizedPath]) {
        return ROUTE_PERMISSION_MAP[normalizedPath];
    }

    // Support detail routes like /daily-collections-view/:id by prefix mapping.
    const matchedPrefix = Object.keys(ROUTE_PERMISSION_MAP)
        .filter((key) => normalizedPath.startsWith(`${key}/`))
        .sort((a, b) => b.length - a.length)[0];

    return matchedPrefix ? ROUTE_PERMISSION_MAP[matchedPrefix] : null;
};

const buildPermissionState = (permissionItem) => {
    if (!permissionItem) return { read: false, write: false, delete: false };

    return {
        read: toPermissionFlag(permissionItem.read_premission),
        write: toPermissionFlag(permissionItem.write_premission),
        delete: toPermissionFlag(permissionItem.delete_premission),
    };
};

const mergePermissionItems = (items) => {
    return {
        read_premission: items.some((item) => toPermissionFlag(item.read_premission)) ? 1 : 0,
        write_premission: items.some((item) => toPermissionFlag(item.write_premission)) ? 1 : 0,
        delete_premission: items.some((item) => toPermissionFlag(item.delete_premission)) ? 1 : 0,
    };
};

/**
 * Get permissions for a specific module or dashboard ID.
 * Priority: Module Name > Dashboard ID
 * @param {number|null} dashboardId - The ID of the dashboard (optional if moduleName is unique)
 * @param {string|null} moduleName - The exact name of the module (e.g., "User Registration")
 * @param {string|null} routePath - Optional route path. If not passed, current URL path is used.
 * @returns {object} { read: boolean, write: boolean, delete: boolean }
 */
export const getPermissions = (dashboardId, moduleName = null, routePath = null) => {
    const accessDashboard = getStoredAccessDashboard();
    if (!accessDashboard.length) {
        return { read: false, write: false, delete: false };
    }

    const routeMeta = getRoutePermissionMeta(routePath);
    const resolvedModuleName = !moduleName || isPlaceholderModuleName(moduleName)
        ? (routeMeta && routeMeta.moduleName) || null
        : moduleName;

    const resolvedDashboardId = parseDashboardId(routeMeta && routeMeta.dashboardId)
        || parseDashboardId(dashboardId);

    const normalizedModuleName = normalizeModuleName(resolvedModuleName);

    if (normalizedModuleName) {
        const byModule = accessDashboard.find((item) =>
            normalizeModuleName(item.module) === normalizedModuleName
        );

        if (byModule) {
            return buildPermissionState(byModule);
        }
        
        // If a specific module was requested but the user doesn't have it,
        // deny access. Do not fall back to dashboard-level permissions.
        return { read: false, write: false, delete: false };
    }

    if (resolvedDashboardId) {
        const byDashboard = accessDashboard.filter(
            (item) => parseDashboardId(item.dashboard_id) === resolvedDashboardId
        );

        if (byDashboard.length) {
            return buildPermissionState(mergePermissionItems(byDashboard));
        }
    }

    return { read: false, write: false, delete: false };
};

export const hasPermission = ({ dashboardId = null, moduleName = null, permissionType = "read", routePath = null } = {}) => {
    const permissions = getPermissions(dashboardId, moduleName, routePath);
    return Boolean(permissions[normalizePermissionType(permissionType)]);
};

export const canAccessRoute = (routePath, permissionType = "read") => {
    const routeMeta = getRoutePermissionMeta(routePath);

    // If route has no mapping, keep behavior backward compatible.
    if (!routeMeta) return true;

    return hasPermission({
        dashboardId: routeMeta.dashboardId,
        moduleName: routeMeta.moduleName,
        permissionType,
        routePath,
    });
};
